<template>
  <div class="home flex flex-col justify-center items-center pb-5 pt-4">
    <img src="../assets/images/pc_banner.png" class="hidden md:block mt-5 max-w-[1140px] w-[97%] z-30" alt="">
    <img src="../assets/images/mb_banner.png" class="md:hidden mt-5 -mb-14 max-w-[906px] w-full z-30" alt="">
    <div class="frame p-3 mt-5 z-20 w-[90%]">
      <div class="frame-inner p-3">
        <div class="frame-content pt-4 pb-20 px-2 md:p-2 text-white">
          <div class="md:flex items-start justify-between">
            <div class="md:w-1/2 w-full mb-3 md:mr-2 md:mb-0">
              <img src="../assets/images/content_1.png" width="100%" alt="">
              <div class="flex mt-4">
                <div class="bg-[#6a0006] text-[#ffd156] text-xs md:text-sm px-2 py-1 text-left mr-[1px] w-[66%] tracking-widest">任務項目</div>
                <div class="bg-[#6a0006] text-[#ffd156] text-xs md:text-sm px-2 py-1 w-[34%] text-center text-nowrap tracking-widest">獎勵點數</div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">1.註冊成功及完成會員資料100%</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/point_20.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">2.至APP 『U問卷』或網頁版『填問卷賺點數』， 完成任一問卷</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/point_80.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">3.至APP『玩任務』的『玩任務拿點數』，完成任一調查</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/point_20.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">4.至APP 『兌好康』、或者網頁版『兌點商城』，兌換任一好禮(不含1點商品)</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/point_20.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="py-3 text-left text-sm md:hidden">
                <p class="font-black">*完成上述所有任務加碼贈送10張抽獎券</p>
                <br>
                因點數贈送名額有限，後續第 4801 位起將更改為送抽獎券<br>
                抽獎券可於APP『兑好康』、官網『兑點商城』投入各式好禮大獎，大幅提升您的中獎機率
              </div>
            </div>
            <div class="md:w-1/2 w-full mb-3 md:mb-0">
              <img src="../assets/images/content_2.png" width="100%" alt="">
              <div class="flex mt-4">
                <div class="bg-[#6a0006] text-[#ffd156] text-xs md:text-sm px-2 py-1 text-left mr-[1px] w-[66%] tracking-widest">任務項目</div>
                <div class="bg-[#6a0006] text-[#ffd156] text-xs md:text-sm sm:px-2 py-1 text-center w-[34%] text-nowrap tracking-widest">獎勵抽獎券</div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">1.註冊成功及完成會員資料100%</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/coupon_5.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">2.至APP 『U問卷』或網頁版『填問卷賺點數』， 完成任一問卷</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/coupon_10.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="flex md:border-none border-b border-[#6a0006] py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base md:border-b border-[#6a0006] flex items-center">3.至APP『玩任務』的『玩任務拿點數』，完成任一調查</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/coupon_5.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
              <div class="flex py-2 md:py-0 md:my-2">
                <div class="w-[66%] md:pb-2 text-left text-sm md:text-base">4.至APP 『兌好康』、或者網頁版『兌點商城』，兌換任一好禮(不含1點商品)</div>
                <div class="w-[34%] flex justify-center items-center">
                  <img src="../assets/images/coupon_5.png" class="w-[70%] md:w-[80%] max-w-[100px]" alt="">
                </div>
              </div>
            </div>
          </div>
          <div class="pb-3 text-left text-sm hidden md:block">
            <p class="font-black">*完成上述所有任務加碼贈送10張抽獎券</p>
            <br>
            因點數贈送名額有限，後續第 4801 位起將更改為送抽獎券<br>
            抽獎券可於APP『兑好康』、官網『兑點商城』投入各式好禮大獎，大幅提升您的中獎機率
          </div>
          <div class="flex items-center justify-between">
            <div class="w-full md:w-3/4 md:mr-3">
              <div class="bg-[#6a0006] text-[#ffd156] text-xs px-2 py-1 text-left w-full tracking-widest">注意事項</div>
              <ul class="text-left leading-5 mt-3 text-xs">
                <li class="mb-3 md:mb-0">1.UUPON點數將於抓取符合資格會員名單後於當月月底完成給點或抽獎券，月底完成之會員將延於隔月月底統一發放(Ex:5月參加活動並完成任務，將於5/31發放點數或抽獎券，5/31完成任務會員將延於6/30發放點數及抽獎券)</li>
                <li class="mb-3 md:mb-0">2.本活動僅限點擊"我要報名"及符合帳號資格參與，報名前皆須先註冊完畢成為UUPON會員</li>
                <li class="mb-3 md:mb-0">3.如忘記密碼，請點擊忘記密碼找回您的密碼。(系統帳號為您的手機號碼)</li>
                <li class="mb-3 md:mb-0">4.若因用戶網路狀況、裝置差異、手機設定、移轉帳號或其他變更等因素導致無法順利完成任務,UUPON 將不負擔任何責任或損害賠償。</li>
                <li class="mb-3 md:mb-0">5.UUPON點數一經扣點進行兌換商品或票券後，視同交易完成，即不接受取消交易或返還點數。</li>
                <li class="mb-3 md:mb-0">6.如遇不可抗拒之天災或非人為造成之因素，點鑽整合行銷股份有限公司（UUPON）有權暫停、延期或取消活動。</li>
                <li>7.如有未盡事宜，悉依相關規定或解釋，點鑽整合行銷股份有限公司（UUPON）得隨時補充公告說明，並保有本次活動最終解釋權。</li>
              </ul>
            </div>
            <img src="../assets/images/pc_btn.png" class="w-1/4 h-full max-w-[280px] hidden md:block" alt="" @click="showModal = true">
          </div>
        </div>
      </div>
    </div>
    <img src="../assets/images/mb_button.png" class="signup-btn w-[70%] md:hidden" alt="" @click="showModal = true">
    <div class="modal-frame" v-if="showModal || noticeModal">
      <div class="modal py-3">
        <div class="w-full"  v-if="showModal">
          <p class="border-b pb-3 text-sm">請輸入報名資訊</p>
          <p class="mt-8 mb-2">手機:<input class="ml-2" type="text" v-model="phone" maxlength="10" placeholder="請填入手機號碼"></p>
          <p class="w-full border-b pb-8">信箱:<input class="ml-2" v-model="mail" type="text" placeholder="請填入信箱"></p>
          <div class="flex justify-center items-center">
            <button class="mt-3 mr-3 text-white rounded-lg px-3 py-1 bg-cyan-500 hover:bg-cyan-600" @click="validateAndSubmit()">確定</button>
            <button class="mt-3 text-white rounded-lg px-3 py-1 bg-zinc-400 hover:bg-zinc-300" @click="showModal = false, phone='', mail=''">取消</button>
          </div>
        </div>
        <div class="w-full" v-if="noticeModal">
          <p class="border-b pb-3 text-sm">提示</p>
          <p class="w-full border-b py-8">{{msg}}</p>
          <button class="mt-3 text-white rounded-lg px-3 py-1 bg-cyan-500 hover:bg-cyan-600 ..." @click="closeModal()">確定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios'

export default {
  name: 'HomeView',
  components: {
    // HelloWorld
  },
  data () {
    return {
      noticeModal: false,
      showModal: false,
      phone: '',
      mail: '',
      msg: '',
      close: true
    }
  },
  created () {
  },
  mounted () {

  },
  methods: {
    closeModal () {
      if (!this.close) {
        location.href = 'https://uupon.tw/s/device.html'
      } else {
        this.noticeModal = false
      }
    },
    validateAndSubmit () {
      if (this.phone === '' || this.mail === '') {
        alert('請完整輸入報名資訊')
        return
      }
      const phoneRegex = /^09\d{8}$/
      const mailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
      if (!phoneRegex.test(this.phone)) {
        alert('手機號碼格式不正確')
        return
      }
      if (!mailRegex.test(this.mail)) {
        alert('信箱格式不正確')
        return
      }
      axios({
        method: 'post',
        url: `https://event.uupon.com/signup/nreg001.php?phone=${this.phone}&email=${this.mail}`
      }).then((response) => {
        this.noticeModal = true
        this.showModal = false
        this.phone = ''
        this.mail = ''
        this.msg = response.data.msg
        if (response.data.code === 100) {
          this.close = false
        } else {
          this.close = true
        }
      })
      // location.href = `https://event.uupon.com/signup/nreg001.php?phone=${this.phone}&email=${this.mail}`
    }
  }
}
</script>
<style lang="scss" scoped>
.home{
  font-family: Helvetica;
  background-image: url('../assets/images/pc_bg.png');
  background-repeat: no-repeat;
  background-size: cover;
  .frame{
    max-width: 1070px;
    border-radius: 20px;
    background-image: linear-gradient(to left, #fc9e00 111%, #d66b11 9%);
    .frame-inner{
      background-color: #4d1111;
      border-radius: 12px;
      .frame-content{
        background-color: #932c11;
        // background: linear-gradient(to left, #333, #333 50%, #eee 75%, #333 75%);
        // background-image: linear-gradient(to top, #932c11, #d66b11);
        // background-image: url(../assets/images/content_bg.png);
        background-size: 100%;
      }
    }
  }
  .modal-frame{
    z-index: 99;
    height: 100vh;
    width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    background: rgba(0,0,0,0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    .modal{
      width: 80%;
      max-width: 300px;
      background: #ffffff;
      border-radius: 16px;
      color: #000000;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }
  .signup-btn{
    margin-top: -50px;
    z-index: 90;
    max-width: 280px;
  }
  input{
    border: 1px solid #989898;
    border-radius: 8px;
    padding: 4px;
  }
}
@media not all and (min-width: 768px) {
  .home{
    background-image: url('../assets/images/mb_bg.png');
    min-width: 320px;
  }
}
</style>
